import { sinatraOrigin } from '../../config'

import keycloakService from '../../keycloak_service'

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const publishPipelineStatusFetch = (publishId) => {
  
  const body = {
    id: publishId
  }
  const fetchOptions = {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  }

  return postToApi('v1/api/pipelines/get_publish_status', fetchOptions)
}
